import React from 'react';
import { Box } from '../../index';

var FormWrapper = function FormWrapper(props) {
  return /*#__PURE__*/React.createElement(Box, props);
};

FormWrapper.defaultProps = {
  maxWidth: '25rem'
};
export default FormWrapper;